import { ReactNode, useRef, useState } from 'react';
import { Button } from '@optimus-web/core';
import { Currency, CurrencySelectDialog } from './CurrencySelectDialog';

interface CurrencySelectDialogButtonProps {
    currencies: Currency[];
    dataTestId: string;
    onChange: (currencyCode: string) => void;
    portalContainerId: string;
    selectedCurrencyCode: string;
    propertyCurrencyCode?: string;
    suggestedCurrencyCodes?: string[];
    dialogTitleText: ReactNode;
    buttonAriaLabelText: string;
    suggestedCurrenciesTitleText?: string;
    otherCurrenciesTitleText: string;
    propertyCurrencyLabelText?: string;
}

export const CurrencySelectDialogButton = ({
    currencies,
    dataTestId,
    onChange,
    portalContainerId,
    propertyCurrencyCode,
    selectedCurrencyCode,
    suggestedCurrencyCodes = [],
    buttonAriaLabelText,
    dialogTitleText,
    suggestedCurrenciesTitleText,
    otherCurrenciesTitleText,
    propertyCurrencyLabelText,
}: CurrencySelectDialogButtonProps) => {
    const [isDialogActive, setIsDialogActive] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const focusButton = () => buttonRef.current?.focus();

    const handleChange = (currencyCode: string) => {
        onChange(currencyCode);
        setIsDialogActive(false);
        focusButton();
    };

    const handleClose = () => {
        setIsDialogActive(false);
        focusButton();
    };

    return (
        <>
            <Button
                aria-label={buttonAriaLabelText}
                data-test-id={dataTestId}
                onClick={() => setIsDialogActive(true)}
                type="button"
                ref={buttonRef}
            >
                {selectedCurrencyCode}
            </Button>
            <CurrencySelectDialog
                currencies={currencies}
                isActive={isDialogActive}
                onChange={handleChange}
                onClose={handleClose}
                portalContainerId={portalContainerId}
                selectedCurrencyCode={selectedCurrencyCode}
                propertyCurrencyCode={propertyCurrencyCode}
                suggestedCurrencyCodes={suggestedCurrencyCodes}
                dialogTitleText={dialogTitleText}
                suggestedCurrenciesTitleText={suggestedCurrenciesTitleText}
                otherCurrenciesTitleText={otherCurrenciesTitleText}
                propertyCurrencyLabelText={propertyCurrencyLabelText}
            />
        </>
    );
};
